var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#f2f2f2"}},[_c('CaseVue',{attrs:{"insti":_vm.insti,"token":_vm.token}}),_vm._v(" "),_c('ManageVue',{attrs:{"insti":_vm.insti,"token":_vm.token}}),_vm._v(" "),_c('FunVue')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-518774d7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cmd_center/Index.vue
// module id = null
// module chunks = 